import { useShopCookieConsentContext } from "context/ShopCookieConsentContext"
import { getAuth, signOut } from "firebase/auth"
import { useShop } from "hooks/firestore/simple/useShop"
import { useUser } from "hooks/firestore/simple/useUser"
import { useCurrentUser } from "hooks/localstate/auth/useCurrentUser"
import getpackedLogo from "images/getpacked_Logo_schwarz.svg"
import Image from "next/image"
import styled from "styled-components"
import { REVOCATION_PRIVACY_NOTICE_PARAGRAPHS, REVOCATION_PRIVACY_NOTICE_TITLE } from "utils/revocationLegalText"

interface FooterProps {
  hideMobile?: boolean
  hideDesktop?: boolean
}

const Footer = styled.div<FooterProps>`
  text-align: center;
  margin-top: 2rem;
  margin-bottom: calc((env(safe-area-inset-bottom, 20px) * 1.5) + 2rem);
  padding-bottom: 70px;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${props => props.theme.breakpoints.large}) {
    display: ${props => (props.hideMobile ? "none" : "flex")};
  }

  @media (min-width: ${props => props.theme.breakpoints.large}) {
    display: ${props => (props.hideDesktop ? "none" : "flex")};
  }
`

const RevocationPrivacyNotice = styled.section`
  max-width: 720px;
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.78);
  color: #2b2b2b;
  text-align: left;
  font-size: 0.82rem;
  line-height: 1.5;

  h2 {
    margin: 0 0 0.5rem;
    font-size: 0.95rem;
    font-weight: 700;
  }

  p {
    margin: 0 0 0.5rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
`

interface SideFooterProps {
  hideMobile?: boolean
  hideDesktop?: boolean
}

const SideFooter = ({ hideMobile, hideDesktop }: SideFooterProps) => {
  const user = useCurrentUser()
  const getpackedUser = useUser()
  const shop = useShop()
  const cookieConsentContext = useShopCookieConsentContext()

  return (
    <Footer hideMobile={hideMobile} hideDesktop={hideDesktop}>
      Powered by{" "}
      <a href="https://getpacked.de/" target="_blank" rel="noreferrer">
        <Image src={getpackedLogo} alt="getpacked logo" />
      </a>
      <br />
      <div>
        {shop?.linkedInfos?.terms && (
          <>
            <a href={shop?.linkedInfos.terms} target="_blank" rel="noreferrer">
              AGB
            </a>
            {" | "}
          </>
        )}
        {shop?.linkedInfos?.dataPrivacy && (
          <>
            <a href={shop?.linkedInfos.dataPrivacy} target="_blank" rel="noreferrer">
              Datenschutzerklärung
            </a>
            {" | "}
          </>
        )}
        <a href="https://getpacked.de/impressum/" target="_blank" rel="noreferrer">
          Impressum
        </a>
        {" | "}
        <a href="https://www.getpacked.de/rechtliches/datenschutzerklaerung-app" target="_blank" rel="noreferrer">
          Platform-Datenschutz
        </a>
        {" | "}
        <a href="https://app.getpacked.de/cookie-declaration">Cookie Erklärung</a>
        {cookieConsentContext?.hasTrackingConfig && (
          <>
            {" | "}
            <a
              href="#"
              onClick={e => {
                e.preventDefault()
                cookieConsentContext.reopenBanner()
              }}
            >
              Cookie-Einstellungen
            </a>
          </>
        )}
        {user ? (
          <>
            {" | "}
            <a href={"#"} onClick={() => signOut(getAuth())}>
              Logout
            </a>
          </>
        ) : null}
        {shop && getpackedUser?.getpackedAdmin ? (
          <>
            {" | "}
            <a href={`/admin/load-shop/${shop._ref.id}?page=orders`}>Shop als Admin bearbeiten</a>
          </>
        ) : null}
      </div>
      {shop?.featureOrderRevocation ? (
        <RevocationPrivacyNotice aria-labelledby="revocation-privacy-notice-title">
          <h2 id="revocation-privacy-notice-title">{REVOCATION_PRIVACY_NOTICE_TITLE}</h2>
          {REVOCATION_PRIVACY_NOTICE_PARAGRAPHS.map(paragraph => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </RevocationPrivacyNotice>
      ) : null}
    </Footer>
  )
}

export default SideFooter
